import { render, staticRenderFns } from "./PasswordNew.vue?vue&type=template&id=40eb373e&scoped=true&"
import script from "./PasswordNew.vue?vue&type=script&lang=js&"
export * from "./PasswordNew.vue?vue&type=script&lang=js&"
import style0 from "./PasswordNew.vue?vue&type=style&index=0&id=40eb373e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eb373e",
  null
  
)

export default component.exports